module.exports = __webpack_public_path__ + "img/fondo.cd9d3307.jpg";